import tools from "../../helpers/tools";

export const AUTH_TYPES = {
  LOAD_CURRENT_USER: "LOAD_CURRENT_USER",
  SET_CURRENT_USER: "SET_CURRENT_USER",
  DELETE_CURRENT_USER: "DELETE_CURRENT_USER",
};

const initialState = {
  isLoading: false,
  isAuthenticated: false,
  user: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case AUTH_TYPES.LOAD_CURRENT_USER:
      return {
        ...state,
        user: {},
        isLoading: action.payload,
      };
    case AUTH_TYPES.SET_CURRENT_USER:
      return {
        ...state,
        isAuthenticated: !tools.isEmpty(action.payload),
        user: action.payload,
        isLoading: false,
      };

    case AUTH_TYPES.DELETE_CURRENT_USER:
      return {
        ...state,
        isAuthenticated: false,
        user: {},
        isLoading: false,
      };

    default:
      return state;
  }
}
